import { IconButton, makeStyles, TextField } from '@material-ui/core';
import qs from 'qs';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, withRouter } from 'react-router-dom';
import { ApplicationState } from '../../reducers';
import { findSubTreeByNodeId } from '../ComponentManagementPage/utils';
import ClearIcon from '@material-ui/icons/Clear';

const useStyles = makeStyles(_ => ({
    root: {
        marginTop: 15,
        marginLeft: 10,
        marginRight: 15,
        marginBottom: 15,
        width: 300
    },
}));


type Props = {
    history: any
}

const TitleSearchComponent: React.FC<Props> = ({ history }) => {

    const [query, setQuery] = useState<string>("");
    const classes = useStyles();
    const treeRoot = useSelector((app: ApplicationState) => app.comp.treeRoot);
    const location = useLocation();

    useEffect(() => {
        if (!treeRoot) {
            setQuery("");
            return;
        }

        const nodeIdParameter = qs.parse(location.search, { ignoreQueryPrefix: true }).node as string;
        if (nodeIdParameter) {
            const nodeId = parseInt(nodeIdParameter);
            const searchNode = findSubTreeByNodeId(treeRoot, nodeId);
            if (searchNode) {
                setQuery(searchNode.citation);
            }
        }
    }, [location.search, treeRoot]);

    const submitSearch = (event: any) => {
        event.preventDefault();

        // Parse tokens from the query string
        const tokens = query.replaceAll('(', '-').replaceAll(')', '-')
            .split('-')
            .filter(t => t.length > 0);

        // Build the path dynamically based on available tokens
        if (tokens.length > 0) {
            const path = `/component/${tokens.slice(0, 7).join('/')}`;
            history.push(path);
        } else {
            history.push(`/component/${query}`);
        }
    }

    return (
        <form onSubmit={(e) => submitSearch(e)} >
            <TextField
                className={classes.root}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                    endAdornment: query && query.length > 0 ?
                        <IconButton size='small' onClick={() => {
                            setQuery("");
                        }}>
                            <ClearIcon />
                        </IconButton>
                        : null
                }}
                variant="outlined"
                size="small"
                placeholder="1-1-110(5)(a)(ii)"
                value={query}
                onChange={(e: any) => { setQuery(e.target.value) }}
            />
        </form>
    )
}

export default withRouter(TitleSearchComponent);